import { render, staticRenderFns } from "./create-skill.vue?vue&type=template&id=6b308f89&"
import script from "./create-skill.vue?vue&type=script&lang=js&"
export * from "./create-skill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports